/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for TitreEnseignantResource controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_FORMATIONAPI, CLIENT_CONTEXT_TOKEN_FORMATIONAPI } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, TitreDTO } from "../models";

@Injectable({ providedIn: "root" })
export class TitreEnseignantResourceService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_FORMATIONAPI);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_FORMATIONAPI;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'formationApi');
    }

    findAllEnseignant(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<TitreDTO>>;
    findAllEnseignant(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<TitreDTO>>>;
    findAllEnseignant(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<TitreDTO>>>;
    findAllEnseignant(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-titres-enseignat`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEnseignant1(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<TitreDTO>>;
    findAllEnseignant1(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<TitreDTO>>>;
    findAllEnseignant1(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<TitreDTO>>>;
    findAllEnseignant1(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-titres-enseignat`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEnseignant2(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<TitreDTO>>;
    findAllEnseignant2(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<TitreDTO>>>;
    findAllEnseignant2(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<TitreDTO>>>;
    findAllEnseignant2(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-titres-enseignat`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEnseignant4(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<TitreDTO>>;
    findAllEnseignant4(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<TitreDTO>>>;
    findAllEnseignant4(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<TitreDTO>>>;
    findAllEnseignant4(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-titres-enseignat`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEnseignant3(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<TitreDTO>>;
    findAllEnseignant3(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<TitreDTO>>>;
    findAllEnseignant3(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<TitreDTO>>>;
    findAllEnseignant3(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-titres-enseignat`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEnseignant6(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<TitreDTO>>;
    findAllEnseignant6(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<TitreDTO>>>;
    findAllEnseignant6(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<TitreDTO>>>;
    findAllEnseignant6(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-titres-enseignat`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEnseignant5(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<TitreDTO>>;
    findAllEnseignant5(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<TitreDTO>>>;
    findAllEnseignant5(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<TitreDTO>>>;
    findAllEnseignant5(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-titres-enseignat`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
